// Colour theme: 'light', 'dark' or 'auto' (follows the system). Remembered per browser.
const KEY = 'theme'
const mq = window.matchMedia('(prefers-color-scheme: dark)')

export function getTheme() {
  try { return localStorage.getItem(KEY) || 'auto' } catch { return 'auto' }
}

export function applyTheme(choice = getTheme()) {
  const dark = choice === 'dark' || (choice === 'auto' && mq.matches)
  document.documentElement.setAttribute('data-bs-theme', dark ? 'dark' : 'light')
}

export function setTheme(choice) {
  try { localStorage.setItem(KEY, choice) } catch { /* private mode: just not remembered */ }
  applyTheme(choice)
}

mq.addEventListener('change', () => applyTheme())
